export const locale = {
  lang: "id",
  data: {
    CART_LIST_CUST: {
      HEADER: "Daftar Keranjang",
      CART_DTL: "Detil Informasi",
      CART_SUM: "Rangkuman Keranjang",
      NO: "No",
      REWARD: "Hadiah",
      POINT: "Poin",
      DECREASE: "Kurangi",
      QUANTITY: "Jumlah Item",
      INCREASE: "Tambahkan",
      TOTAL_POINT: "Jumlah Poin",
      TOTAL_REQUIRED_POINT: "Jumlah Poin yang Dibutuhkan",
      TOTAL_ITEM: "Jumlah Item Hadiah",
      REDEEM_REQ: "Tukar Hadiah",
      REDEEM_NOW: "Tukar Sekarang",
      ERROR_REDEEM: "*Kamu tidak memiliki poin aktif yang cukup untuk tukar hadiah",
      ERROR_EMPTY_REDEEM: "*Tambahkan beberapa hadiah ke keranjang untuk tukar hadiah",
      DATA_NOT_FOUND: "Tidak Ada Data ...",
    },
  },
};
